import type { DefaultContext, OperationVariables } from "@apollo/client";
import { useMutation as useApolloMutation } from "@apollo/client/react";
import {
  type ForbiddenAwareOnError,
  withWrappedForbiddenOnError,
} from "./wrapForbiddenAwareOnError";

export function useMutation<
  TData = unknown,
  TVariables extends OperationVariables = OperationVariables,
>(
  mutationDocument: Parameters<typeof useApolloMutation<TData, TVariables>>[0],
  options?: Parameters<typeof useApolloMutation<TData, TVariables>>[1] &
    Record<string, unknown> & {
      context?:
        | DefaultContext
        | ((hookContext: DefaultContext | undefined) => DefaultContext);
      onError?: ForbiddenAwareOnError;
    }
) {
  const contextForSkipFlag =
    typeof options?.context === "function" ? undefined : options?.context;

  const mergedOptions =
    options === undefined
      ? undefined
      : (withWrappedForbiddenOnError(
          options,
          contextForSkipFlag
        ) as unknown as Parameters<
          typeof useApolloMutation<TData, TVariables>
        >[1]);

  return useApolloMutation<TData, TVariables>(mutationDocument, mergedOptions);
}
